import { SPACING_UNIT } from "@assets/style/appMuiTheme"

export namespace MemberOnboardingConstants {
  export const CONTENT_MAX_WIDTH = 650
  export const MARGIN_TOP = "8vh"
  export const CONTENT_MARGIN_TOP = SPACING_UNIT * 4
}
